<template>
    <div>
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-2">
                            <br>
                            <a href="/event/list">
                                <svg style="height:14px;width:14px;fill:#999;margin-top: -10px;">
                                    <use xlink:href="/images/<.svg#page_left"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>注目のイベント</b>
                            </div>
                        </div>
                        <div class="col-2">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:60px;"></div>
        <div class="wrap">
            <div class="row" style="padding-top:15px;">
                <div class="col">
                    <small style="padding-top:8px;color:#7b7b7b">イベント数 {{
                        events.length |
                        priceLocaleString
                    }}件</small>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <div v-for="event in events" :key="event.id">
                        <div style="padding:0 10px 30px 10px;">
                            <a :href="'/event/details/' + event.id" style="text-decoration:none;">
                                <div class=""
                                    style="width: 100%;box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 20px 0px;border-radius: 20px;overflow: hidden;">
                                    <div style="position: absolute;padding: 20px;">
                                        <div class="owner_label" v-if="event.owner_status == 1">
                                            <svg style="height:18px;width:18px;fill:#fff;margin-top:-3px;">
                                                <use xlink:href="/images/label_event_luna.svg#label_event_luna">
                                                </use>
                                            </svg>&nbsp;Luna主催
                                        </div>
                                        <div class="owner_label" v-else>
                                            ユーザー投稿
                                        </div>
                                    </div>
                                    <img :src="event.img_url" style="width: 100%; height:auto;min-height:100px;">
                                    <div>
                                        <div class="text-center footer_event_after_box"
                                            v-if="isEventEnd(event.event_at_to)">
                                            開催終了
                                        </div>
                                        <div class="text-center footer_event_befor_box" v-else-if="event.is_preparation">
                                            <div class="row">
                                                <div class="col text-start">
                                                    受付準備中
                                                </div>
                                                <div class="col text-end">
                                                    定員 {{ event.member_count }}人
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center footer_event_now_box" v-else-if="event.is_recruiting">
                                            <div class="row">
                                                <div class="col text-start">
                                                    &nbsp;&nbsp;参加者募集中
                                                </div>
                                                <div class="col text-end">
                                                    定員 {{ event.member_count }}人&nbsp;&nbsp;
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center footer_event_befor_box" v-else>
                                            申込上限に達しました
                                        </div>
                                    </div>
                                    <div style="padding-top:15px;padding-bottom:15px;" :class="setBackColor(event)">
                                        <div class="row">
                                            <div class="col-1"></div>
                                            <div class="col-3 text-center" style="border-right: 1px solid #E6E6E6;">
                                                <div style="font-size:20px;">
                                                    {{ setWeekDay(event.event_at_from) }}
                                                </div>
                                                <div style="font-size:12px;">
                                                    {{ setDaysWithJp(event.event_at_from) }}〜
                                                </div>
                                                <div v-if="event.event_type == 1"
                                                    style="font-size:12px;border:1px solid #C6C4FF;border-radius: 4px;">
                                                    2部制
                                                </div>
                                                <div v-else-if="event.event_type == 2"
                                                    style="font-size:12px;border:1px solid #C6C4FF;border-radius: 4px;">
                                                    3部制
                                                </div>
                                            </div>
                                            <div class="col">
                                                <h5 style="color:#000">{{ event.thumbnail }}</h5>

                                                <div style="display:flex">
                                                    <div style="padding-right:5px">
                                                        <i class="bi bi-clock"
                                                            style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                    </div>
                                                    <div>
                                                        <div v-if="event.event_type == 1">
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                1部　{{ setDaysWithSlash(event.event_at_from_1) }}{{
                                                                    setRmDate(event.event_at_from_text_1) }}</div>
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                2部　{{ setDaysWithSlash(event.event_at_from_2) }}{{
                                                                    setRmDate(event.event_at_from_text_2) }}</div>
                                                        </div>
                                                        <div v-if="event.event_type == 2">
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                1部　{{ setDaysWithSlash(event.event_at_from_1) }}{{
                                                                    setRmDate(event.event_at_from_text_1) }}</div>
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                2部　{{ setDaysWithSlash(event.event_at_from_2) }}{{
                                                                    setRmDate(event.event_at_from_text_2) }}</div>
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                3部　{{ setDaysWithSlash(event.event_at_from_3) }}{{
                                                                    setRmDate(event.event_at_from_text_3) }}</div>
                                                        </div>
                                                        <div v-else>
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                {{ setDaysWithSlash(event.event_at_from) }}{{
                                                                    setRmDate(event.event_at_from_text) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="display:flex">
                                                    <div style="padding-right:5px">
                                                        <i class="bi bi-geo-alt"
                                                            style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                    </div>
                                                    <div>
                                                        <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">
                                                            {{ event.address_view }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-1"></div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            events: [],
        };
    },
    methods: {
        async fetchEvent() {
            await axios.get("/api/event/full/pickup")
                .then((response) => {
                    // events が欠落した 200 でも template の events.length / v-for が壊れないようにする
                    this.events = Array.isArray(response.data.events) ? response.data.events : [];
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        //window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの取得に失敗しました")
                    }
                })
        },
        isEventEnd(event) {
            let event_date = event.split(' ')[0]
            let eDate = new Date(event_date.split('-')[0], event_date.split('-')[1] - 1, event_date.split('-')[2])
            let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            return (eDate < today);
        },
        setWeekDay(event) {
            let event_date = event.split(' ')[0]
            let eDate = new Date(event_date.split('-')[0], event_date.split('-')[1] - 1, event_date.split('-')[2])
            let dayOfWeek = eDate.getDay()
            let dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek]

            return dayOfWeekStr
        },
        setDaysWithJp(event) {
            let event_date = event.split(' ')[0]
            return Number(event_date.split('-')[1]) + '月' + Number(event_date.split('-')[2]) + '日'
        },
        setDaysWithSlash(event) {
            let event_date = event.split(' ')[0]
            return Number(event_date.split('-')[1]) + '/' + Number(event_date.split('-')[2])
        },
        setRmDate(event) {
            return event.substr(10) + '〜';
        },
        setBackColor(event) {
            let c = "";

            if (this.isEventEnd(event.event_at_to)) {
                c = "end_back"
            }
            else if (event.is_preparation) {
                c = "preparation_back"
            }
            else if (event.is_recruiting) {
                c = "recruiting_back"
            }
            else {
                c = "up_back"
            }

            return c
        },
    },
    filters: {
        priceLocaleString(value) {
            return value.toLocaleString()
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchEvent()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.fetchEvent()
            }
        }
        else {
            this.fetchEvent()
        }
    },
};
</script>

<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

.luna-search-con-box {
    padding: 15px;
    background-color: #fff;
    border-radius: 10px;
}

.end_back {
    background-color: #E6E6E6;
}

.preparation_back {
    background-color: #E7E7FF;
}

.recruiting_back {
    background-color: #fff;
}

.up_back {
    background-color: #E7E7FF;
}

.footer_event_after_box {
    background-color: #cdcdcd;
    color: #999;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_befor_box {
    background-color: #C6C4FF;
    color: #6B4EFF;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_now_box {
    background-color: #6B4EFF;
    color: #fff;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.owner_label {
    color: #fff;
    background-color: #6b4eff;
    padding: 5px 20px 5px 15px;
    border-radius: 20px;
}
</style>
